// extracted by mini-css-extract-plugin
module.exports = {"loaderSpinner":"Loader_loaderSpinner__eMBua"};